export enum UserOrganizationStatus {
  LINKED = 'Linked',
  PENDING = 'Pending',
  REJECTED = 'Rejected'
}

